/** Configuration types for the composition pattern analysis. */

/** Configuration for the composition pattern (undirected wiring diagram) analysis. */
export type CompositionPatternConfig = {};

/** Default configuration. */
export const defaultCompositionPatternConfig = (): CompositionPatternConfig => ({});
